<template>
  <div>
    <div :id="type" :class="type" @click="sendGA(type)"></div>
    <div
      v-if="typeAux !== ''"
      :id="typeAux"
      :class="typeAux"
      @click="sendGA(typeAux)"
    ></div>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";

const props = defineProps({
  type: {
    type: String,
    default: ""
  },
  typeAux: {
    type: String,
    default: ""
  }
});

const showAd = ref(true);
const debounce = ref(null);
const debounceAux = ref(null);
const analitycsDebounce = ref(null);
const analitycsAttemps = ref(0);
const analitycsDebounceAux = ref(null);
const analitycsAttempsAux = ref(0);

onMounted(() => {
  debounce.value = setTimeout(() => {
    let typeElement = document.getElementById(props.type);
    if (typeElement && typeElement) {
      clearTimeout(debounce.value);
      let itHas = false;
      if (typeElement.children && typeElement.children.length > 0) {
        for (let i = 0; i < typeElement.children.length; i++) {
          if (typeElement.children[i].tagName === "SCRIPT") {
            itHas = true;
          }
        }
      }
      if (!itHas) {
        let recaptchaScript = document.createElement("script");
        let typeShort = props.type.replace(/\-/g, "");
        recaptchaScript.innerHTML =
          "googletag.cmd.push(function() { googletag.display('" +
          props.type +
          "'); googletag.pubads().refresh([" +
          typeShort +
          "]);  }); ";
        typeElement.appendChild(recaptchaScript);
      }
      if (props.typeAux) {
        debounceAux.value = setTimeout(() => {
          let typeAuxElement = document.getElementById(props.typeAux);
          if (typeAuxElement) {
            clearTimeout(debounceAux.value);
            let itHasAux = false;
            if (typeAuxElement.children && typeAuxElement.children.length > 0) {
              for (let i = 0; i < typeAuxElement.children.length; i++) {
                if (typeAuxElement.children[i].tagName === "SCRIPT") {
                  itHasAux = true;
                }
              }
            }
            if (!itHasAux) {
              let recaptchaScriptaUX = document.createElement("script");
              let typeAuxShort = props.typeAux.replace(/\-/g, "");
              recaptchaScriptaUX.innerHTML =
                "googletag.cmd.push(function() { googletag.display('" +
                props.typeAux +
                "'); googletag.pubads().refresh([" +
                typeAuxShort +
                "]);  });";
              typeAuxElement.appendChild(recaptchaScriptaUX);
            }
          }
        }, 250);
      }
    }
  }, 250);
  // Aqui se enviaban eventos de analitycs sobre los anuncios
  // this.analitycsDebounce = setTimeout(()=> {
  //   this.analitycsAttemps++;
  //   let typeElement = document.getElementById(props.type)
  //   if (typeElement && typeElement.children && typeElement.children[1] && typeElement.children[1].children.length > 0) {
  //     if (this.$gtag && typeof this.$gtag.event === 'function'){
  //       this.$gtag.event(props.type, {
  //         'event_category': 'ads'
  //       });
  //       this.analitycsAttemps = 11;
  //     }
  //   }
  //   if (this.analitycsAttemps > 10) {
  //     clearTimeout(this.analitycsDebounce)
  //   }
  // }, 1000);
  // if (props.typeAux) {
  //   this.analitycsDebounceAux = setTimeout(()=> {
  //     this.analitycsAttempsAux++;
  //     let typeElementAux = document.getElementById(props.type)
  //     if (typeElementAux && typeElementAux.children && typeElementAux.children[1] && typeElementAux.children[1].children.length > 0) {
  //       if (this.$gtag && typeof this.$gtag.event === 'function'){
  //         this.$gtag.event(props.typeAux, {
  //           'event_category': 'ads'
  //         });
  //         this.analitycsAttempsAux = 11;
  //       }
  //     }
  //     if (this.analitycsAttempsAux > 10) {
  //       clearTimeout(this.analitycsDebounceAux)
  //     }
  //   }, 1000);
  // }
});

const sendGA = eventName => {
  //   if (this.$gtag && typeof this.$gtag.event === 'function'){
  //     this.$gtag.event(eventName + '_click', {
  //       'event_category': 'ads'
  //     });
  //   }
};
</script>
